<template>
  <div>
    <pack-info :packId="packId"></pack-info>
    <v-container>
      <v-row class="och-topMargin--packInfoOffset" v-if="isUatOpen" justify-center>
        <v-col sm="12">
          <v-card class="och-table--borders-light-grey">
            <v-card-title class="title font-weight-thin py-2">Test Step Details and Outcomes</v-card-title>
            <v-card-text>
              <phi-warning class="mb-n2"></phi-warning>
            </v-card-text>
            <v-card-text>
              <member-test-step-form
                redirectionPath="testPlanView"
                :releaseNoteId="releaseNoteId"
                :serviceAreaId="serviceAreaId"
                :testStepId="testStepId"
                mode="edit"
              ></member-test-step-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="och-topMargin--packInfoOffset" v-if="!isUatOpen" justify-center>
        <v-col sm="12" md10>
          <v-alert icon="fas fa-lock" type="info">UAT is currently closed, editing has been disabled</v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import MemberTestStepForm from "@/components/memberTestStepForm";
import PackInfo from "@/components/packInfo";
import PhiWarning from "@/components/PhiWarning";

export default {
  name: "memberTestPlanEdit",
  components: {
    MemberTestStepForm,
    PackInfo,
    PhiWarning,
  },
  computed: {
    packId() {
      return parseInt(this.$route.params.packId, 10);
    },
    releaseNoteId() {
      return parseInt(this.$route.params.releaseNoteId, 10);
    },
    serviceAreaId() {
      return parseInt(this.$route.params.serviceAreaId, 10);
    },
    testStepId() {
      return parseInt(this.$route.params.testStepId, 10);
    },
    ...mapGetters({
      isUatOpen: "pack/isUatOpen",
    }),
  },
};
</script>
